import { defineMessages } from 'react-intl';

export default defineMessages({
    noneOptionLabel: {
        defaultMessage: 'None',
        description: 'Label for the radio group option to select no options.',
        id: 'sd.customerview.field.radio.group.none.option',
    },
});
